import { render, staticRenderFns } from "./AccountTerminologyIndex.vue?vue&type=template&id=f438e9b4"
import script from "./AccountTerminologyIndex.vue?vue&type=script&lang=js"
export * from "./AccountTerminologyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports